export default __webpack_public_path__ + "static/media/3076.da8d3d70.jpg";